import AnalyticsHelper from '../../utils/analytics-helper.js';
import LazyLoader from '../../utils/lazy-loader.js';
import Animate from '../helpers/animate.js';
import SecondaryLink from './secondary-link.js';
import SavedCars from './saved-cars';

export default class Flyout {
    constructor(parent, el) {
        this.parent = parent;
        this.el = el;
        this.html = parent.html;
        this.body = parent.body;
        this.mask = parent.mask;
        this.flyout = el.querySelector('.nav__flyout');
        this.primary = el.querySelector('.link--primary');
        this.secondaryLinks = [...el.querySelectorAll('.link--secondary')].map((el) => new SecondaryLink(this, el));
        this.items = [...this.flyout.querySelectorAll(':scope > div > ul > li')];

        this.savedCars();

        this.flyoutProductsDynamicPlaceholder = this.flyout.querySelector('script[data-content-path]');
        if (!this.flyoutProductsDynamicPlaceholder) {
            this.bind();
            this.checkLazyContent();
        } else {
            this.primary.addEventListener("click", (e) => { this.loadAndCheckLazyContent(e); }, { once: true });
        }
    }

    checkLazyContent() {
        const self = this;
        if (self.primary.classList.contains('is-lazy')) {
            const lazyContainer = this.flyout.querySelector('.lazy-load-container');

            const finalCallBack = function (e) {
                lazyContainer.classList.add('lazy-loaded');
                self.primary.removeEventListener('click', clickHandler);
            };

            const lazyLoader = new LazyLoader(lazyContainer, 0, '', finalCallBack);

            const clickHandler = function (e) {
                lazyLoader.load();
            };

            self.primary.addEventListener('click', clickHandler);
        }
    }

    async loadAndCheckLazyContent(e) {
        e.preventDefault();

        let flyoutProducts;

        // Open and start animating existing elements in the flyout
        this.open();

        const flyoutProductsDynamicUrl = this.flyoutProductsDynamicPlaceholder.dataset.contentPath;
        try {
            const response = await fetch(flyoutProductsDynamicUrl);

            if (!response.ok) {
                console.error(`Unable to download data for Navigation Flyout Products from ${flyoutProductsDynamicUrl}`, response.status);
            }

            flyoutProducts = Array.from(this.parseFlyoutProductsStringToDom(await response.text()));
        } catch (error) {
            console.error(`Unable to download data for Navigation Flyout Products from ${flyoutProductsDynamicUrl}.`, error.message);
        }

        if (flyoutProducts === undefined) {
            this.primary.addEventListener('click', (e) => {
                if (this.el.classList.contains('expand')){
                    e.preventDefault();
                    this.close();
                    this.primary.addEventListener("click", (e) => { this.loadAndCheckLazyContent(e); }, { once: true });
                } else {
                    this.loadAndCheckLazyContent(e);
                }
            }, { once: true });
            return;
        }

        // Init SecondaryLink logic for new nested elements
        flyoutProducts.forEach((flyoutProduct) => {
            [...flyoutProduct.querySelectorAll('.link--secondary')].map((el) => new SecondaryLink(this, el));
        });

        // Update animatable items putting products to be first to animate
        this.items = flyoutProducts.concat(this.items);

        // Inject elements into DOM
        this.flyoutProductsDynamicPlaceholder.replaceWith(...flyoutProducts);

        this.open();
        this.bind();

        const lazyContainer = this.flyout.querySelector('.lazy-load-container');
        (new LazyLoader(lazyContainer, 0, '', () => lazyContainer.classList.add('lazy-loaded'))).load();
    }

    // eslint-disable-next-line class-methods-use-this
    parseFlyoutProductsStringToDom(text) {
        const domParser = new DOMParser();
        const domElements = domParser.parseFromString(text, 'text/html');
        return domElements.querySelector('.header').children;
    }

    bind() {
        this.primary.addEventListener('click', (e) => this.toggle(e));
    }

    toggle(e) {
        e.preventDefault();
        AnalyticsHelper.push(this.primary);
        this.el.classList.contains('expand') ? this.close() : this.open();
    }

    close() {
        this.el.classList.remove('expand');
        this.flyout.classList.remove('items--expanded');
        this.flyout.querySelectorAll('.items--expanded').forEach((el) => el.classList.remove('items--expanded'));
        this.flyout.querySelectorAll('.expand--secondary').forEach((el) => el.classList.remove('expand--secondary'));
        this.mask.hide();
        this.parent.update();
        this.primary.setAttribute('aria-expanded', 'false');
    }

    open() {
        this.parent.close();
        this.parent.update();
        this.el.classList.add('expand');
        this.flyout.classList.add('items--expanded');
        Animate.addClass(this.items, 'items--expanded', 100)
            .then(() => this.resize());
        Animate.scroll(this.el);
        this.mask.show();
        this.primary.setAttribute('aria-expanded', 'true');
    }

    resize() {
        this.parent.resize(this.flyout.clientHeight);
    }

    windowResize() {
        if (this.html.classList.contains('no-touch') || window.innerWidth > 1024) {
            this.items.forEach((el) => el.classList.remove('expand--secondary'));
        }
    }

    savedCars() {
        if(this.el.querySelector('.configured-car-link-wrapper') || this.el.querySelector('.saved-cars-link-wrapper')){
            this.savedCars = new SavedCars(this);
        }
    }
}
